import { brl } from "../../lib/data";
import { calcPricing, fmtDate } from "../../lib/pricing";

const Row = ({ label, value, strong, testid }) => (
  <div className="flex justify-between gap-4 text-sm">
    <span className="text-zinc-400">{label}</span>
    <span data-testid={testid} className={strong ? "font-display font-bold text-white" : "text-zinc-200"}>{value}</span>
  </div>
);

export const Summary = ({ form }) => {
  const p = calcPricing(form);
  return (
    <aside data-testid="booking-summary" className="rounded-[26px] border border-white/10 bg-[#111219] p-7 relative overflow-hidden">
      <div className="absolute -top-20 -right-20 w-56 h-56 rounded-full bg-[#FFD200]/10 blur-3xl" />
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#FFD200]">Resumo da reserva</p>
      <p className="mt-3 font-display font-black text-2xl text-white">{p.pkg.label} · {p.pkg.name}</p>
      <div className="mt-6 space-y-3">
        <Row label={`Pacote (${p.pkg.hours}h)`} value={brl(p.pkg.price)} />
        {!p.pkg.noExtras && <Row label={`Pelúcias extras (${form.extras})`} value={brl(form.extras * 15)} />}
        <Row label="Data" value={`${fmtDate(form.eventDate)}${form.eventTime ? ` · ${form.eventTime}` : ""}`} />
        <Row label="Cidade" value={form.city || "—"} />
        <div className="h-px bg-white/10 my-2" />
        <Row label="Subtotal" value={brl(p.subtotal)} />
        {p.discount > 0 && <Row label="Desconto à vista (5%)" value={`− ${brl(p.discount)}`} testid="summary-discount" />}
        <Row label="Total do evento" value={brl(p.total)} strong testid="summary-total" />
      </div>
      <div className="mt-6 rounded-2xl bg-[#FFD200] text-[#08080C] p-5">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em]">{form.option === "full" ? "Pagar agora (integral)" : "Pagar agora (sinal 30%)"}{form.method === "pagarme" ? " · até 12x" : ""}</p>
        <p className="font-display font-black text-3xl mt-1" data-testid="summary-due-now">{brl(p.dueNow)}</p>
        {form.method === "pagarme" && <p className="text-sm mt-1" data-testid="summary-installments-note">No cartão em até 12x. Juros do parcelamento por conta do cliente (1x sem juros).</p>}
        {p.remaining > 0 && <p className="text-sm mt-1">Restante {brl(p.remaining)} até {p.dueDate || "10 dias antes"}</p>}
      </div>
    </aside>
  );
};
